import { render, staticRenderFns } from "./CommissionDefinition.vue?vue&type=template&id=4fde717d&scoped=true"
import script from "./CommissionDefinition.vue?vue&type=script&lang=js"
export * from "./CommissionDefinition.vue?vue&type=script&lang=js"
import style0 from "./CommissionDefinition.vue?vue&type=style&index=0&id=4fde717d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fde717d",
  null
  
)

export default component.exports